import React, { useCallback, useState, memo } from 'react';
import {
    Box,
    IconButton,
    Menu,
    MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import { ReactComponent as Logo } from '../logo.svg';

export const Header = memo(() => {
    const {t, i18n} = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const isLanguageMenuOpen = Boolean(anchorEl);

    const handleLanguageMenuClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    const handleLanguageClick = useCallback((e) => {
        setAnchorEl(e.currentTarget);
    }, []);

    const handleLanguageSelect = useCallback((lang) => {
        i18n.changeLanguage(lang)
        handleLanguageMenuClose();
    }, [i18n, handleLanguageMenuClose]);

    return (
        <React.Fragment>
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-end'
            }}>
                <Box>
                    <IconButton onClick={handleLanguageClick} sx={{p: '0px'}}>
                        <LanguageOutlinedIcon sx={{ fontSize: 30 }} />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={isLanguageMenuOpen}
                        onClose={handleLanguageMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}>
                        <MenuItem onClick={() => handleLanguageSelect('en')}>{t('langSelectEn')}</MenuItem>
                        <MenuItem onClick={() => handleLanguageSelect('es')}>{t('langSelectEs')}</MenuItem>
                    </Menu>
                </Box>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    alignItems: 'center'
            }}>
                <Logo width="256px" height="auto"/>

            </Box>
        </React.Fragment>
    )
});
